import { render, staticRenderFns } from "./LinkdeConviteIndex.vue?vue&type=template&id=35c054cd&scoped=true"
import script from "./LinkdeConviteIndex.vue?vue&type=script&lang=js"
export * from "./LinkdeConviteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c054cd",
  null
  
)

export default component.exports